import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_SUPPLIER_REQUEST,
  CREATE_SUPPLIER_SUCCESS,
  CREATE_SUPPLIER_FAILURE,
  GET_ALL_SUPPLIER_REQUEST,
  GET_ALL_SUPPLIER_SUCCESS,
  GET_ALL_SUPPLIER_FAILURE,
  GET_ONE_SUPPLIER_REQUEST,
  GET_ONE_SUPPLIER_SUCCESS,
  GET_ONE_SUPPLIER_FAILURE,
  EDIT_SUPPLIER_REQUEST,
  EDIT_SUPPLIER_SUCCESS,
  EDIT_SUPPLIER_FAILURE,
  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
  UPLOADCSV_SUPPLIER_INFORMATION_REQUEST,
  UPLOADCSV_SUPPLIER_INFORMATION_SUCCESS,
  UPLOADCSV_SUPPLIER_INFORMATION_FAILURE,
} from "./supplierTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

// --- CREATE API ---
const createSupplierRequest = () => ({
  type: CREATE_SUPPLIER_REQUEST,
});
const createSupplierSuccess = (payload) => ({
  type: CREATE_SUPPLIER_SUCCESS,
  payload,
});
const createSupplierFailure = (error) => ({
  type: CREATE_SUPPLIER_FAILURE,
  payload: error,
});

const createSupplierInformation = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createSupplierRequest());
    let url = `${baseUrl}/dpp/supplier_information/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createSupplierSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createSupplierFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- GET ALL API ---
const getAllSupplierRequest = () => ({
  type: GET_ALL_SUPPLIER_REQUEST,
});
const getAllSupplierSuccess = (payload) => ({
  type: GET_ALL_SUPPLIER_SUCCESS,
  payload,
});
const getAllSupplierFailure = (error) => ({
  type: GET_ALL_SUPPLIER_FAILURE,
  payload: error,
});

const getAllSupplierInformation = (jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getAllSupplierRequest());
    let url = `${baseUrl}/dpp/supplier_information/get`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAllSupplierSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAllSupplierFailure(err.message));
      });
  };
};

// --- GET ONE API ---
const getOneSupplierRequest = () => ({
  type: GET_ONE_SUPPLIER_REQUEST,
});
const getOneSupplierSuccess = (payload) => ({
  type: GET_ONE_SUPPLIER_SUCCESS,
  payload,
});
const getOneSupplierFailure = (error) => ({
  type: GET_ONE_SUPPLIER_FAILURE,
  payload: error,
});

const getOneSupplierInformation = (supplierId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getOneSupplierRequest());
    let url = `${baseUrl}/dpp/supplier_information/get_one?supplierId=${supplierId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOneSupplierSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOneSupplierFailure(err.message));
      });
  };
};

// --- EDIT API ---
const editSupplierRequest = () => ({
  type: EDIT_SUPPLIER_REQUEST,
});
const editSupplierSuccess = (payload) => ({
  type: EDIT_SUPPLIER_SUCCESS,
  payload,
});
const editSupplierFailure = (error) => ({
  type: EDIT_SUPPLIER_FAILURE,
  payload: error,
});

const editSupplierInformation = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editSupplierRequest());
    let url = `${baseUrl}/dpp/supplier_information/update`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editSupplierSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editSupplierFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- DELETE API ---
const deleteSupplierRequest = () => ({
  type: DELETE_SUPPLIER_REQUEST,
});
const deleteSupplierSuccess = (payload) => ({
  type: DELETE_SUPPLIER_SUCCESS,
  payload,
});
const deleteSupplierFailure = (error) => ({
  type: DELETE_SUPPLIER_FAILURE,
  payload: error,
});

const deleteSupplierInformation = (supplierId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteSupplierRequest());
    let url = `${baseUrl}/dpp/supplier_information/delete?supplierId=${supplierId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteSupplierSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteSupplierFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForSupplierInformationRequest = () => ({
  type: UPLOADCSV_SUPPLIER_INFORMATION_REQUEST,
});

const uploadCsvForSupplierInformationSuccess = (payload) => ({
  type: UPLOADCSV_SUPPLIER_INFORMATION_SUCCESS,
  payload: payload,
});

const uploadCsvForSupplierInformationFailure = (error) => ({
  type: UPLOADCSV_SUPPLIER_INFORMATION_FAILURE,
  payload: error,
});

  const uploadCsvForSupplierInformation = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForSupplierInformationRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_supplier_information/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForSupplierInformationSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForSupplierInformationFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createSupplierInformation,
  getAllSupplierInformation,
  getOneSupplierInformation,
  editSupplierInformation,
  deleteSupplierInformation,
  uploadCsvForSupplierInformation,
};